import React from 'react'
import {Link} from 'react-router-dom';
const Slider = () => {
  return (
    <section id="c-sectionMainSlider" style={{backgroundImage: "url('./images/home/banner/slider_bg.png')"}}>
		<div className="container">
			<div id="c-mainSlider" className="carousel slide" data-ride="carousel">			  
			  <div className="carousel-inner">
				<div className="carousel-item active" 
					style={{backgroundImage: "url('./images/home/banner/banner1.png')"}}>
					<div className="carousel-caption">
						<h5>Lending your money the quickest way with care</h5>
						<p>Lending Beyond the Ordinary to make your dream come true, the EV way!</p>
						<Link to='/dealer' className="c-btnWhiteBrdr c-scrollToDiv" data-scroll-to="#c-sectionRequestInfoForm">Get in Touch &nbsp;&nbsp; <b>></b></Link>
					</div>					
				</div>
				<div className="carousel-item" 
					style={{backgroundImage: "url('./images/home/banner/banner2.png')"}}>
					<div className="carousel-caption">
						<h5>We value your originality, money-wise!</h5>
						<p>Partnering with lenders, automotive dealers and OEMs to provide them with a single digital platform in the EV segment</p>
						<Link to='/dealer' className="c-btnWhiteBrdr c-scrollToDiv" data-scroll-to="#c-sectionRequestInfoForm">Get in Touch &nbsp;&nbsp; <b>></b></Link>
					</div>
				</div>
				<div className="carousel-item" 
					style={{backgroundImage: "url('./images/home/banner/banner3.png')"}}>
					<div className="carousel-caption">
						<h5>We serve what you deserve</h5>
						<p className="mt-5 mb-5 pb-5">Instant and paperless loan approval for your next EV</p>
						<Link to='/dealer' className="c-btnWhiteBrdr c-scrollToDiv" data-scroll-to="#c-sectionRequestInfoForm">Get in Touch &nbsp;&nbsp; <b>></b></Link>
					</div>
				</div>
			  </div>
			  <ol className="carousel-indicators">
				<li data-target="#c-mainSlider" data-slide-to="0" className="active"></li>
				<li data-target="#c-mainSlider" data-slide-to="1"></li>
				<li data-target="#c-mainSlider" data-slide-to="2"></li>
			  </ol>
			  <button className="carousel-control-prev" type="button" data-target="#carouselExampleCaptions" data-slide="prev">
				<span className="carousel-control-prev-icon" aria-hidden="true"></span>
				<span className="sr-only">Previous</span>
			  </button>
			  <button className="carousel-control-next" type="button" data-target="#carouselExampleCaptions" data-slide="next">
				<span className="carousel-control-next-icon" aria-hidden="true"></span>
				<span className="sr-only">Next</span>
			  </button>
			</div>
		</div>
	</section>
  )
}

export default Slider